import React, { useEffect, useRef } from "react";
import { css } from "@emotion/react";
import { ModalDialogWithClose } from "main/javascripts/components/modal/ModalDialogWithClose";
import { stopBodyScrolling } from "main/javascripts/utils/ScrollUtil";
import { useConstructor } from "main/javascripts/hooks/common/useConstructor";

export interface IProps {
  displayed: boolean;
  header?: React.ReactNode;
  children: React.ReactNode;
  closeHandler(): void;
  colorMode?: string;
}

export const FullScreenModalDialog: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { children, header, displayed, closeHandler, colorMode } = props;
  const prevDisplayed = useRef(displayed);

  useConstructor(() => {
    // backキー等で戻った場合に再度抑止する
    if (displayed) {
      stopBodyScrolling(displayed);
    }
  });

  useEffect(() => {
    if (displayed) {
      if (!prevDisplayed.current) {
        stopBodyScrolling(displayed);
      }
    } else {
      if (prevDisplayed.current) {
        stopBodyScrolling(displayed);
      }
    }
    prevDisplayed.current = displayed;
  }, [displayed]);

  let currentInnerStyle: any = innerStyle;
  let currentCloseStyle: any = closeStyle;
  if (colorMode === "light") {
    currentInnerStyle = innerLightStyle;
    currentCloseStyle = closeLightStyle;
  }
  return (
    <ModalDialogWithClose
      displayed={displayed}
      closeHandler={closeHandler}
      styles={{
        exInnerStyle: currentInnerStyle,
        exInnerContentStyle: innerContentStyle,
        exCloseButtonStyle: closeButtonStyle,
        exCloseStyle: currentCloseStyle,
      }}
    >
      {header}
      {children}
    </ModalDialogWithClose>
  );
};

const innerStyle = css`
  background-color: #232323;
  width: calc(100% + 1px);
  height: calc(100% + 1px);
  max-width: calc(100% + 1px);
  max-height: calc(100% + 1px);
  box-shadow: none;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
`;
const innerContentStyle = css``;
const closeButtonStyle = css`
  opacity: 1;
  &:hover {
    opacity: 0.7;
  }
`;
const closeStyle = css`
  color: #fff;
`;
const innerLightStyle = css`
  background-color: #fff;
  width: calc(100% + 1px);
  height: calc(100% + 1px);
  max-width: calc(100% + 1px);
  max-height: calc(100% + 1px);
  box-shadow: none;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
`;
const closeLightStyle = css`
  color: #232323;
`;
